import React from 'react';

type Props = {
  quality?: any;
  isDarkMode: boolean;
};

const LABELS: Record<string, string> = {
  strong_local: 'Strong',
  good_local: 'Good',
  regional_model: 'Regional',
  limited: 'Limited',
  unavailable: 'Unavailable',
};

export default function WaterIntelQualityBadge({ quality, isDarkMode }: Props) {
  const raw = String(quality?.label || 'unavailable');
  const label = LABELS[raw] || raw.replace(/_/g, ' ');
  const confidence = Number(quality?.confidence);
  const confidenceLabel = Number.isFinite(confidence)
    ? `${Math.round(confidence * 100)}%`
    : null;

  return (
    <span
      className="inline-flex min-w-0 items-center gap-1 rounded-full border px-1.5 py-0.5 text-[7.5px] font-black uppercase tracking-[0.06em]"
      style={{
        background: isDarkMode ? 'rgba(124,199,255,0.07)' : 'rgba(234,247,255,0.78)',
        borderColor: isDarkMode ? 'rgba(124,199,255,0.14)' : 'rgba(110,185,226,0.18)',
        color: isDarkMode ? '#CDEFFF' : '#246C91',
      }}
      title={confidenceLabel ? `${label} · ${confidenceLabel}` : label}
    >
      <span className="truncate">{label}</span>
      {confidenceLabel ? <span className="opacity-55">{confidenceLabel}</span> : null}
    </span>
  );
}
